import reducers from './reducers'

export { default as tagsTypes } from './types'
export { default as tagsActions } from './actions'
export { default as tagsSelectors } from './selectors'
export { default as tagsEpics } from './epics'

export default reducers
